import React from "react";
import face from '../assets/images/face.png';
import dw4bw4 from '../assets/images/dw4bw4.jpg';
import saica from '../assets/images/saica.jpg';
import apollotds from '../assets/images/apollotds.png';
import simmre from '../assets/images/simmre.jpg';
import homeassistant from '../assets/images/homeassistant.jpg';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects so far...</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://www.ebd.csic.es/node/19171" target="_blank" rel="noreferrer"><img src={simmre} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.ebd.csic.es/node/19171" target="_blank" rel="noreferrer"><h2>Intelligent multi-sensor systems for remote monitoring of species - Employee</h2></a>
                <p>In process of developing an intelligent and autonomous system for remote monitoring of bird species. The project will feature a smart nest box able of identifying and capturing a species individual by using a set of electronic sensors and actuators.</p>
            </div>
            <div className="project">
                <a href="https://www.home-assistant.io/" target="_blank" rel="noreferrer"><img src={homeassistant} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.home-assistant.io/" target="_blank" rel="noreferrer"><h2>Self-hosted home automation system - Freelance</h2></a>
                <p>Developed a self-hosted smart home solution with remote access through Cloudflare and Home Assistant.</p>
            </div>
            <div className="project">
                <a href="https://dragadosoffshore.com/experiencia/" target="_blank" rel="noreferrer"><img src={dw4bw4} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://dragadosoffshore.com/experiencia/" target="_blank" rel="noreferrer"><h2>Dolwin 4/Borwin 4 - Employee</h2></a>
                <p>Developed instrumentation wiring diagrams and managed the central instrumentation and control (I&C) databases.</p>
            </div>
            <div className="project">
                <a href="https://apollotds.com/" target="_blank" rel="noreferrer"><img src={apollotds} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://apollotds.com/" target="_blank" rel="noreferrer"><h2>Appollo TDS - Employee</h2></a>
                <p>Developed high level design, designed wiring schematics and manufacturing procedure and developed real-time responsive firmware.</p>
            </div>
            <div className="project">
                <a href="https://www.saicasl.eu/servicios/gestion_calibraciones" target="_blank" rel="noreferrer"><img src={saica} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.saicasl.eu/servicios/gestion_calibraciones" target="_blank" rel="noreferrer"><h2>Calibration Process Design - Internship</h2></a>
                <p>Designed and Developed calibration processes for electrical measurement equipments.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;